import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getToken = () => localStorage.getItem("jwt_token");

const authHeader = () => ({
  Authorization: `Bearer ${getToken()}`,
});

export const checkHotelRegistrationLimit = async () => {
  const res = await axios.get(
    `${API_URL}/agents/check-hotel-limit`,
    {
      headers: authHeader(),
    }
  );
  return res.data;
};

export const checkGuideRegistrationLimit = async () => {
  const res = await axios.get(
    `${API_URL}/agents/check-guide-limit`,
    {
      headers: authHeader(),
    }
  );
  return res.data;
};

export const submitAgentLimitIncreaseRequest = async (type, reason) => {
  const res = await axios.post(
    `${API_URL}/agents/limit-increase-request/${type}`,
    { request: reason },
    {
      headers: authHeader(),
    }
  );
  return res.data;
};


export const validateCityZip = async (city, zip) => {
  const res = await axios.post(
    `${API_URL}/validate-city-zip`,
    { city, zip },
    { headers: authHeader() }
  );
  return res.data.isValid;
};



export const validateNicDob = async (nic, dob) => {
  const res = await axios.post(
    `${API_URL}/validate-nic-dob`,
    { nic, dob },
    { headers: authHeader() }
  );
  return res.data.isValid;
};

export const validateNicGender = async (nic, genderId) => {
  const res = await axios.post(
    `${API_URL}/validate-nic-gender`,
    { nic, genderId },
    { headers: authHeader() }
  );
  return res.data.isValid;
};

export const validateCityDistrict = async (city, districtId) => {
  const res = await axios.post(
    `${API_URL}/validate-city-district`,
    { city, districtId },
    { headers: authHeader() }
  );
  return res.data.isValid;
};


export const fetchPropertyTypes = async () => {
  const res = await axios.get(`${API_URL}/property_types`);
  return res.data;
};


export const fetchGenders = async () => {
  const res = await axios.get(`${API_URL}/genders`);
  return res.data;
};


export const fetchCountries = async () => {
  const res = await axios.get(`${API_URL}/countries`);
  return res.data;
};


export const fetchNationalities = async () => {
  const res = await axios.get(`${API_URL}/nationalities`);
  return res.data;
};

export const fetchDistricts = async () => {
  const res = await axios.get(`${API_URL}/districts`);
  return res.data;
};


export const registerAgentHotel = async (formData) => {
  const res = await axios.post(
    `${API_URL}/agents/register-hotel`,
    formData,
    {
      headers: {
        ...authHeader()
      },
    }
  );

  return res.data;
};

export const getAgentDetails = async () => {
  const token = localStorage.getItem("jwt_token");

  const res = await axios.get(`${API_URL}/agents/details`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return res.data;
};